import React, { useCallback, useEffect, useState } from "react";
import {
  Dimensions,
  ImageBackground,
  Modal,
  Platform,
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Image } from "expo-image";
import globalstyle from "../../../Styles/Globals/globals";
import constants from "@/config/constants";
import { LinearGradient } from "expo-linear-gradient";
import { perfilStyles } from "./PerfilStyle";
import InfoModal from "../Modals/InfoModal";
import { useNavigation } from "@react-navigation/native";
import { useGlobal } from "../../Context/globalContext";
import { useAuth } from "../../Context/authContext";
import { puntsPerItinerari } from "@/Components/Functions/utils";
import Markdown from "react-native-markdown-display";
import ImageViewer from "react-native-image-zoom-viewer";
import { WebView } from "react-native-webview";
import useMediaType from "@/hooks/useMediaType";
import { ResizeMode, Video } from "expo-av";

const { width } = Dimensions.get("window");

const PartSuperior = (itinerari: any) => {
  const { __, textRecurs, imatgeRecurs, projecte } = useGlobal();
  const { user } = useAuth();

  const [modalInfoVisible, setModalInfoVisible] = useState(false);
  const navigation = useNavigation<any>();

  const myItinerari = user.progres.itineraris[itinerari.id] ?? {
    pois: [],
  };

  const poisPrincipals = itinerari.pois.filter((p) => p.latitud);

  const poisCompletats = Object.values(myItinerari.pois).filter((p: any) =>
    poisPrincipals.map((p) => p.id).includes(p.id),
  );

  const numPoisCompletats = poisCompletats.length;

  const itinerariCompletat: boolean =
    numPoisCompletats === poisPrincipals.length;

  const poisDelItinerari = poisPrincipals.length;

  const goToReward = ({}) => {
    navigation.navigate("PuzzlePerfil", { itinerari, mostraGif: false });
  };

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 12,
        backgroundColor: constants.colorCardBg,
        marginTop: 5,
        paddingTop: 10,
        marginHorizontal: 16,
        paddingHorizontal: 20,
      }}
    >
      <Image
        source={{ uri: itinerari.imatge?.url }}
        style={{ width: 70, height: 70 }}
      />

      <View>
        <View style={{ flexDirection: "column" }}>
          <Text
            style={{
              fontFamily: "GeorgiaBold",
              fontSize: 28,
              color: "#484848",
              textAlign: "center",
            }}
          >
            {__(itinerari, "nom")}
          </Text>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Markdown
              style={{
                body: {
                  fontFamily: "Roboto",
                  color: "#484848",
                },
              }}
            >
              {__(itinerari, "subtitol") || " "}
            </Markdown>
          </View>
        </View>
        <View
          style={{
            flexDirection: "column",
            paddingTop: 10,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <LinearGradient
              colors={[constants.colorLinearGx, constants.colorLinearGy]}
              style={[
                perfilStyles.smallContainer,
                perfilStyles.marginContainer,
              ]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
            >
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={{
                    marginRight: 5,
                    fontFamily: "Roboto",
                    fontSize: 14,
                    color: "#484848",
                    fontWeight: "700",
                    textTransform: "lowercase",
                  }}
                >
                  {puntsPerItinerari(myItinerari)}
                </Text>

                <Text
                  style={{
                    marginRight: 5,
                    fontFamily: "Roboto",
                    fontSize: 14,
                    color: "#484848",
                    textTransform: "lowercase",
                  }}
                >
                  {textRecurs("general_puntos")}
                </Text>
              </View>
            </LinearGradient>
            <LinearGradient
              colors={[constants.colorLinearGx, constants.colorLinearGy]}
              style={perfilStyles.smallContainer}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
            >
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={{
                    marginRight: 5,
                    fontFamily: "Roboto",
                    fontSize: 14,
                    color: "#484848",
                    fontWeight: "700",
                  }}
                >
                  {numPoisCompletats}/{poisDelItinerari}
                </Text>

                <Text
                  style={{
                    marginRight: 5,
                    fontFamily: "Roboto",
                    fontSize: 14,
                    color: "#484848",
                    textTransform: "lowercase",
                  }}
                >
                  {textRecurs("general_lugares")}
                </Text>
              </View>
            </LinearGradient>
          </View>
          <TouchableOpacity
            onPress={goToReward}
            disabled={!itinerariCompletat}
            style={{
              ...perfilStyles.buttonVerRecompensa,
              backgroundColor: itinerari.color_fons1,
              opacity: itinerariCompletat ? 1 : 0.4,
            }}
          >
            <Text style={{ color: "white" }}>
              {textRecurs("poi_ver_recompensa")}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      {InfoModal(itinerari, modalInfoVisible, setModalInfoVisible)}
    </View>
  );
};

const ImagenesPerfil = (itinerari: any) => {
  const { user } = useAuth();
  const { imatgeRecurs, textRecurs } = useGlobal();

  const [modalPremiVisible, setModalPremiVisible] = useState(false);
  const [index, setIndex] = useState(0);

  const myItinerari = user.progres.itineraris[itinerari.id] ?? {
    pois: [],
  };

  const numFiles = Math.ceil(itinerari.pois.length / 2);

  const tincElPremiDelPoi = (id: number) => !!myItinerari.pois[id];

  const ModalPremiGaleria = ({
    modalPremiVisible,
    setModalPremiVisible,
    index,
  }) => {
    const premi = itinerari.pois[index].premi;

    return (
      <Modal
        transparent={false}
        visible={modalPremiVisible}
        onRequestClose={() => setModalPremiVisible(false)}
      >
        {premi.url ? (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <View style={globalstyle.closeButton}>
              <Pressable
                onPress={() => setModalPremiVisible(false)}
                style={globalstyle.closeButtonPressable}
              >
                <Image
                  source={{ uri: imatgeRecurs("boton_cerrar") }}
                  style={{ width: 16, height: 16 }}
                />
              </Pressable>
            </View>
            {Platform.OS === "web" ? (
              <iframe
                src={premi.url}
                height={"60%"}
                width={"100%"}
                style={{ border: "none" }}
              />
            ) : (
              <WebView
                source={{
                  uri: premi.url,
                }}
                style={{
                  border: "none",
                  height: 300,
                  width: 400,
                  flex: 1,
                }}
                allowFullScreen={true}
              />
            )}
          </View>
        ) : (
          <ImageViewer
            renderHeader={() => (
              <Pressable
                onPress={() => setModalPremiVisible(false)}
                style={{
                  ...globalstyle.closeButton,
                  backgroundColor: "white",
                  padding: 10,
                  borderRadius: 12,
                }}
              >
                <Image
                  source={{ uri: imatgeRecurs("boton_cerrar") }}
                  style={{ width: 13, height: 13 }}
                />
              </Pressable>
            )}
            imageUrls={[
              {
                url: premi.multimedia?.url,
              },
            ]}
          />
        )}
      </Modal>
    );
  };

  const quadrePremi = useCallback(
    (index: number) => {
      const premi = itinerari.pois[index]?.premi;
      const uri = premi?.multimedia?.url;

      const mediaType = useMediaType(uri);

      if (!premi || !uri) {
        return;
      }

      if (mediaType === "image") {
        return (
          <Image
            source={{
              uri,
            }}
            contentFit={"contain"}
            style={{
              alignSelf: "center",
              flex: 1,
              width: "95%",
              maxHeight: "100%",
              opacity: tincElPremiDelPoi(itinerari.pois[index].id) ? 1 : 0.2,
              borderRadius: 12,
            }}
          />
        );
      }

      if (mediaType === "video") {
        return (
          <Video
            source={{
              uri,
            }}
            style={{
              alignSelf: "center",
              flex: 1,
              width: "95%",
              maxHeight: "100%",
              opacity: tincElPremiDelPoi(itinerari.pois[index].id) ? 1 : 0.2,
              borderRadius: 12,
            }}
            useNativeControls
            resizeMode={ResizeMode.CONTAIN}
            rate={1.0}
            volume={1.0}
            isMuted={false}
            shouldPlay={false}
            videoStyle={{
              width: "100%",
              height: "100%",
            }}
          />
        );
      }
    },
    [itinerari.pois],
  );

  const mostraElPremi = (index: number) => {
    if (!tincElPremiDelPoi(itinerari.pois[index].id)) {
      return;
    }

    setIndex(index);
    setModalPremiVisible(true);
  };

  const filaDePremis = useCallback(
    (fila) => {
      return (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            height: 150,
            gap: 10,
            marginBottom: 10,
          }}
        >
          <Pressable
            style={{ flex: 1, width: "100%", height: "100%" }}
            onPress={() => mostraElPremi(fila * 2)}
          >
            {quadrePremi(fila * 2)}
          </Pressable>
          <Pressable
            style={{ flex: 1, width: "100%", height: "100%" }}
            onPress={() => mostraElPremi(fila * 2 + 1)}
          >
            {quadrePremi(fila * 2 + 1)}
          </Pressable>
        </View>
      );
    },
    [quadrePremi],
  );

  return (
    <View
      style={{
        height: "90%",
        marginTop: 20,
        borderTopLeftRadius: 32,
        borderTopRightRadius: 32,
        backgroundColor: "#F9F7E8",
      }}
    >
      <View style={perfilStyles.overlayHeader}>
        <Text
          style={{
            fontFamily: "Poppins",
            fontWeight: "700",
            marginBottom: 10,
            fontSize: 20,
          }}
        >
          {textRecurs("general_imagenes")}
        </Text>
      </View>

      <ScrollView
        style={{
          width,
          // flex: 1,
          marginBottom: 100,
          height: 0,
        }}
      >
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: Platform.OS === "web" ? 100 : 600,
            marginTop: 20,
          }}
        >
          {Array.from({ length: numFiles }, (_, i) => (
            <View style={{ width: "100%" }} key={i}>
              {filaDePremis(i)}
            </View>
          ))}
        </View>
      </ScrollView>
      <ModalPremiGaleria
        modalPremiVisible={modalPremiVisible}
        setModalPremiVisible={setModalPremiVisible}
        index={index}
      />
    </View>
  );
};

export default function PerfilItinerari(RouterData: any) {
  const { imatgeRecurs, textRecurs } = useGlobal();
  const navigation = useNavigation();

  const itinerari = RouterData.route.params.itinerari;

  useEffect(() => {
    navigation.getParent()?.setOptions({
      tabBarStyle: {
        display: "none",
      },
    });
    return () =>
      navigation.getParent()?.setOptions({
        tabBarStyle: undefined,
      });
  }, [navigation]);

  return (
    <View style={globalstyle.containerBg}>
      <ImageBackground
        source={{ uri: itinerari.fons?.url }}
        style={{ ...globalstyle.backgroundImatges, alignItems: "center" }}
      >
        <View
          style={{
            alignSelf: "flex-start",
            marginLeft: 30,
            marginTop: Platform.OS === "ios" ? 30 : 5,
          }}
        >
          <Pressable
            onPress={() => navigation.goBack()}
            style={{
              marginTop: 5,
            }}
          >
            <Image
              source={{ uri: imatgeRecurs("boton_atras") }}
              style={{ height: 25, width: 25 }}
            />
          </Pressable>
        </View>
        <PartSuperior {...itinerari} />
        <ImagenesPerfil {...itinerari} />
      </ImageBackground>
    </View>
  );
}
